<template>
    <div :class="styles.about_view">
        <div :class="styles.about_view__inner">
            <!-- GUIDE MOBILE -->
            <div :class="styles.about_view__guide">
                <div :key="guide" v-for="(guide, index) in listGuide"
                    :class="[styles.about_view__guide_item, activeGuide === index ? styles.guide_active : '']"
                    @click="setActiveGuide(index)">
                    {{ guide }}
                </div>
            </div>
            <div :class="styles.about_view__guide_spacer"></div>
            <!-- GUIDE MOBILE -->

            <div :class="styles.about_view__about">
                <div :class="styles.about_view__wrapper">
                    <!-- GUIDE DESKTOP -->
                    <div :class="styles.about_view__guide_desktop">
                        <div :key="guide" v-for="(guide, index) in listGuide"
                            :class="[styles.about_view__guide_item_deskop, activeGuide === index ? styles.guide_desktop__active : '']"
                            @click="setActiveGuide(index)">
                            {{ guide }}
                        </div>
                    </div>
                    <!-- GUIDE DESKTOP -->

                    <breadcrumbs :items="listBreadcrumb" />

                    <div :class="styles.about_view__about_inner">
                        <div :class="styles.about_view__about_text">
                            <h1>Tentang Agrofarm</h1>
                            <div :class="styles.about_view__about_desc" v-if="about && about.attributes"
                                v-html="about.attributes.description"></div>
                        </div>
                        <div :class="styles.about_view__about_desc_image">
                            <img alt="Tentang Agrofarm" class="h-full" :src="require(`@/assets/AboutTop.svg`) " />
                        </div>
                    </div>
                </div>
            </div>

            <about-landing :disableButton="true" />

            <visi-misi :data="about" />
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import styles from "./AboutsView.module.css"
import AboutLanding from '../landing/about/AboutLanding.vue';
import breadcrumbs from "@/components/ui/breadcrumb/BreadcrumbUi.vue";
import { useStore } from "vuex";
import VisiMisi from './visimisi/VisiMisi.vue';

export default {
    name: "AboutsView",
    components: {
        AboutLanding,
        breadcrumbs,
        VisiMisi,
    },
    setup() {
        const store = useStore();
        const listBreadcrumb = ref([
            {
                title: "Dashboard",
                disabled: false,
                href: "/",
            },
            {
                title: "Tentang Agrofarm",
                disabled: true,
                href: "#",
            }
        ]);

        const listGuide = ['Tentang', 'Nilai Perusahaan', 'Visi & Misi', 'Sejarah'];
        const activeGuide = ref(0);

        const about = computed(() => {
            return store.getters.getAbout;
        });

        const setActiveGuide = (index) => {
            activeGuide.value = index;
        };

        onMounted(() => {
            setTimeout(() => {
                console.log('about', about.value)
            }, 1000)
            store.dispatch("getAbout");
        });

        return {
            styles,
            listBreadcrumb,
            listGuide,
            activeGuide,
            setActiveGuide,
            about
        };
    }
};
</script>